export const getTrafficStatusMap = (state) =>
  state.trafficStatusMap.trafficStatus;
export const getLoadingTrafficStatusMap = (state) =>
  state.trafficStatusMap.loadingTrafficStatus;
export const getTrafficStatusMapV2 = (state) =>
  state.trafficStatusMap.trafficStatusV2;
export const getLoadingTrafficStatusMapV2 = (state) =>
  state.trafficStatusMap.loadingTrafficStatusV2;
export const getTrafficStatusRectangle = (state) =>
  state.trafficStatusMap.trafficStatusRectangle;
export const getLoadingTrafficStatusRectangle = (state) =>
  state.trafficStatusMap.loadingTrafficRectangle;
export const getTrafficStatusCircle = (state) =>
  state.trafficStatusMap.trafficStatusCircle;
export const getLoadingTrafficStatusCircle = (state) =>
  state.trafficStatusMap.loadingTrafficCircle;

